import React from 'react';
import {Button, Menu, MenuItem, MenuDivider, Icon} from '@mc/ui-v4';
import {DataGridRowVO, RightsApi, UserRightsVO} from '../../../api';
import {defaultUpdateAction} from '../../sidebar/FeatureDetailSidebar';
import {WaitForQueryData} from '@mc/react-app-v4';
import {useQuery} from 'react-query';
import {CACHE_KEY_USER_LAYER_OPRAVNENI} from '../../../queryKeys';
import {EditorEventType, LayerId, ActionTypes} from '@mc/react-mapio';
import {mcDelete, mcEdit} from '@mc/react-ui-icons';
import {UserAction} from '../AttributeTableFinal';

type ActionButtonsProps = {
    row: DataGridRowVO;
    rowIndex: number;
    handleUpdateClick: (row: DataGridRowVO, action: UserAction | null) => Promise<void>;
    handleDeleteClick: (row: DataGridRowVO) => Promise<void>;
    layerId: LayerId;
};

export const AttributeTableRowActions = ({row, rowIndex, handleUpdateClick, handleDeleteClick, layerId}: ActionButtonsProps) => {
    const useOpravneniQuery = useQuery<UserRightsVO[]>(
        [CACHE_KEY_USER_LAYER_OPRAVNENI, layerId],
        async () => (await RightsApi.getAllLayerRightsForLoggedInUser([Number(layerId)])).data,
        {enabled: !!layerId},
    );
    return (
        <WaitForQueryData queries={[useOpravneniQuery]}>
            {() => {
                const opravneniData: UserRightsVO[] = useOpravneniQuery.data;
                const userActions = opravneniData[0]?.layers[0].actionRights.actionList
                    ?.map(akce => {
                        if (akce.typ === 'UPDATE') {
                            return {
                                label: akce.nazev,
                                type: EditorEventType.ACTION,
                                actionId: ActionTypes.NAVIGATE_TO_USER_LAYER_EDIT,
                                featureId: row.id,
                                layerId: layerId,
                                akceId: akce.id,
                            };
                        }
                    })
                    .filter(Boolean);

                return (
                    <Button
                        style="link"
                        key={rowIndex}
                        disabled={
                            !(opravneniData[0]?.layers[0]?.vlastnikVrstvy || opravneniData[0]?.layers[0]?.actionRights?.allActions || userActions?.length)
                        }
                        menu={
                            <Menu>
                                {userActions?.map(action => {
                                    return (
                                        <MenuItem
                                            key={action?.label}
                                            onClick={async (): Promise<void> => {
                                                await handleUpdateClick(row, action);
                                            }}
                                            text={
                                                <>
                                                    <Icon icon={mcEdit} /> {action?.label}
                                                </>
                                            }
                                        />
                                    );
                                })}
                                {(opravneniData[0]?.layers[0]?.vlastnikVrstvy || opravneniData[0]?.layers[0]?.actionRights?.allActions) && (
                                    <>
                                        <MenuItem
                                            onClick={async (): Promise<void> => {
                                                await handleUpdateClick(row, null);
                                            }}
                                            text={
                                                <>
                                                    <Icon icon={mcEdit} /> {defaultUpdateAction}
                                                </>
                                            }
                                        />
                                        <MenuDivider />
                                        <MenuItem
                                            onClick={async () => {
                                                await handleDeleteClick(row);
                                            }}
                                            text={
                                                <>
                                                    <Icon icon={mcDelete} /> Smazat
                                                </>
                                            }
                                        />
                                    </>
                                )}
                            </Menu>
                        }
                    />
                );
            }}
        </WaitForQueryData>
    );
};
